const FIXED_HOLIDAYS = Object.freeze({
  "01-01": "Jour de l'An",
  "05-01": "Fête du Travail",
  "05-08": "Victoire 1945",
  "07-14": "Fête Nationale",
  "08-15": "Assomption",
  "11-01": "Toussaint",
  "11-11": "Armistice 1918",
  "12-25": "Noël",
});

const HOLIDAYS_BY_YEAR = new Map();

const pad2 = (n) => String(n).padStart(2, "0");

function toISO(date) {
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
}

function addDays(date, days) {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
}

function easterDate(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day, 12, 0, 0);
}

export function getFrenchPublicHolidays(year) {
  const y = Number(year);
  if (!Number.isInteger(y) || y < 1900 || y > 2200) return {};
  if (HOLIDAYS_BY_YEAR.has(y)) return HOLIDAYS_BY_YEAR.get(y);

  const holidays = {};
  Object.entries(FIXED_HOLIDAYS).forEach(([mmdd, label]) => {
    holidays[`${y}-${mmdd}`] = label;
  });

  const easter = easterDate(y);
  holidays[toISO(addDays(easter, 1))] = "Lundi de Pâques";
  holidays[toISO(addDays(easter, 39))] = "Ascension";
  holidays[toISO(addDays(easter, 50))] = "Lundi de Pentecôte";

  HOLIDAYS_BY_YEAR.set(y, holidays);
  return holidays;
}

export function getFrenchHolidayName(dateIso) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(String(dateIso || ""))) return "";
  const year = Number(String(dateIso).slice(0, 4));
  return getFrenchPublicHolidays(year)[dateIso] || "";
}

export function isFrenchPublicHoliday(dateIso) {
  return Boolean(getFrenchHolidayName(dateIso));
}
